import * as XLSX from "xlsx";

export const BUSINESS_TYPES = [
  "Hospital",
  "Rural bank",
  "Credit union",
  "Microfinance",
  "SACCO",
  "Finance company",
];

export const BUSINESS_TYPE_OTHER = "__other__";

export const BUSINESS_TYPE_OPTIONS = [
  ...BUSINESS_TYPES.map((type) => ({ value: type, label: type })),
  { value: BUSINESS_TYPE_OTHER, label: "Other" },
];

export const REGIONS = [
  "Greater Accra",
  "Ashanti",
  "Western",
  "Western North",
  "Central",
  "Eastern",
  "Volta",
  "Oti",
  "Northern",
  "Savannah",
  "North East",
  "Upper East",
  "Upper West",
  "Bono",
  "Bono East",
  "Ahafo",
];

/** Details the commercial executive must collect before the onboard form can be submitted. */
export const PROVIDER_ONBOARDING_FIELDS = [
  {
    label: "Legal name",
    ask: "The registered or trading name.",
    example: "Sevolink Finance",
    format: "The name that should appear on the portal and on reports.",
  },
  {
    label: "Business type",
    ask: "What kind of institution this is.",
    example: "Finance company",
    format: `${BUSINESS_TYPES.join(", ")}, or another type written in full.`,
  },
  {
    label: "Region",
    ask: "The Ghana region where they operate.",
    example: "Greater Accra",
    format: "One region from the list on the template.",
  },
  {
    label: "Primary email",
    ask: "The inbox they will use to sign in.",
    example: "ops@institution.example",
    format: "Portal login and the welcome email go to this address.",
  },
  {
    label: "Primary phone",
    ask: "A working Ghana contact number.",
    example: "0241234567",
    format: "024XXXXXXX, 020XXXXXXX, or 233XXXXXXXXX.",
  },
  {
    label: "Total SLA (days)",
    ask: "The total recovery window for this provider.",
    example: "20",
    format: "Whole days. On the onboard form, the commercial executive splits this into call centre manager days and call centre agent days.",
  },
];

export function downloadInstitutionOnboardingTemplate() {
  const headers = PROVIDER_ONBOARDING_FIELDS.map((field) => field.label);
  const sample = PROVIDER_ONBOARDING_FIELDS.map((field) => field.example);
  const sheet = XLSX.utils.aoa_to_sheet([headers, sample, headers.map(() => "")]);
  sheet["!cols"] = headers.map((header) => ({ wch: Math.max(header.length + 4, 28) }));

  const instructions = [
    ["SimCollect institution onboarding"],
    [""],
    ["Use this sheet before the provider is on the portal."],
    ["Collect only these fields. They are enough to open the institution, set the SLA, and send the login email."],
    ["After the provider signs in, they can add city, address, website, logo, a second contact, and social links."],
    ["Collect the total SLA days only. On the onboard form, the commercial executive decides how many of those days go to the call centre manager and how many go to the call centre agent."],
    [""],
    ["Field", "What to ask", "Example", "How to write it"],
    ...PROVIDER_ONBOARDING_FIELDS.map((field) => [field.label, field.ask, field.example, field.format]),
    [""],
    ["Business types"],
    ...BUSINESS_TYPES.map((type) => ["", type]),
    ["", "Or write another type in full"],
    [""],
    ["Regions"],
    ...REGIONS.map((region) => ["", region]),
    [""],
    ["Fill the Provider sheet. Leave the sample row or replace it with the institution you are onboarding."],
  ];
  const help = XLSX.utils.aoa_to_sheet(instructions);
  help["!cols"] = [{ wch: 22 }, { wch: 42 }, { wch: 28 }, { wch: 64 }];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, "Provider");
  XLSX.utils.book_append_sheet(workbook, help, "What to collect");
  XLSX.writeFile(workbook, "SimCollect_institution_onboarding.xlsx");
}
